<template>
  <div class="carousel-skeleton">
    <div class="skeleton-image"></div>
    <div class="skeleton-content">
      <div class="skeleton-title"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CarouselSkeleton'
}
</script>

<style scoped>
.carousel-skeleton {
  width: 100%;
  height: 400px;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}

.skeleton-image {
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #f0f0f0 25%, #f8f8f8 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

.skeleton-content {
  position: absolute;
  bottom: 35%;
  left: 0;
  width: 100%;
  padding: 0 50px;
  text-align: center;
}

.skeleton-title {
  width: 70%;
  height: 36px;
  margin: 0 auto;
  border-radius: 4px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.3) 25%, rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0.3) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
</style> 